<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="10">
        <h2 class="grey--text">{{ $t("설문 조사 안내") }}</h2>
        <!-- <p>
      <strong>{{ message }}</strong>
    </p> -->
        <v-alert
        class="mt-4"
        outlined
          border="left"
          color="grey"
          prominent
        >
          <!-- colored-border -->
          <!-- elevation="2" -->
          <template #prepend>
            <v-icon color="grey" large>mdi-information-outline</v-icon>
          </template>
          <div class="text-h6 grey--text">{{message}}</div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
    },
    msgCode: {
      type: String,
    },
  },
};
</script>

<style scoped>
/* .container {
  margin: 50px auto 40px auto;
  width: 600px;
  text-align: center;
} */
/* p {
  color: rgba(0, 0, 0, 0.5);
  margin: 20px 0;
  line-height: 1.6;
} */
</style>
